<template>
  <transition name="el-fade-in-linear">
	    <div v-show="transitionshow">      
	  	
          <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
              <el-form-item>
				  <el-select v-model="query.timetype" placeholder="时间搜索类型" @change="query.ischange=true">
					  <el-option v-for="(item,index) in timetypelists" :label="item.name" :value="item.id" :key="index"></el-option>
				  </el-select>
			  </el-form-item>
              <el-form-item>
				  <el-date-picker v-model="query.date" type="daterange" style="width:100%"
					  range-separator="至"
					  start-placeholder="开始日期"
					  end-placeholder="结束日期"
					  value-format="yyyy-MM-dd" :unlink-panels="false" @change="query.ischange=true">
				  </el-date-picker>
			  </el-form-item>
              <el-form-item style="width:11%">
				  <el-select v-model="query.status" placeholder="订单状态" filterable clearable @change="query.ischange=true">
					  <el-option v-for="(item,index) in orderstatus" :label="item.name" :value="item.id" :key="index"></el-option>
				  </el-select>
			  </el-form-item>

              <el-form-item>
                  <el-input placeholder="请输入抖店订单号 / 成交店铺 / 收货人姓名 / 收货人电话" v-model="query.key" clearable @keyup.enter.native="getTmalllists" @change="query.ischange=true" style="width:100%"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
              </el-form-item>
              <el-form-item>
                  <el-tooltip class="item" effect="dark" content="手动获取抖店订单信息" placement="top">
                      <el-button type="success" icon="el-icon-upload2" @click="uploadTmallOrder">上传抖店订单信息</el-button>
                  </el-tooltip>
              </el-form-item>
	      </el-form>

          <div class="backborder2" style="margin-top:10px">
			  <el-table :data="lists" style="width:100%" v-loading="query.loading">
                  <el-table-column type="expand">
                      <template slot-scope="props">
                          <div class="tmall-order-reciever">
                            收货信息：{{props.row.reciever_name}}，{{props.row.reciever_phone}}，{{props.row.province}} - {{props.row.city}} - {{props.row.down}} - {{props.row.street}}（详细地址：{{props.row.address}}）
                            <el-button type="" round size="mini" @click="checksells(props.row)">查看销售出库单</el-button>
                            <el-button type="" round size="mini"  @click="getpackshippings(props.row.id)">查看物流单</el-button>
                          </div>

                          <el-table :data="props.row.goods">
                            <el-table-column label="goodsid" width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.id}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="商品名称">
                                <template slot-scope="goodsinfos">
                                    <div class="tmall-order-goods">
                                        <div class="tmall-order-goods-img">
                                            <span class="tmall-order-goods-gift" v-if="goodsinfos.row.type==2">赠</span>
                                            <img :src="goodsinfos.row.product_pic ? goodsinfos.row.product_pic : require('../../assets/default_img_mini.png')" /></div>
                                        <div class="tmall-order-goods-name">{{goodsinfos.row.product_name}}</div>
                                        <div class="tmall-order-goods-spec">{{goodsinfos.row.spec}}</div>
                                        <div class="tmall-order-goods-spec">商品ID：{{goodsinfos.row.dshopproductid}}，sku_id：{{goodsinfos.row.dshopskuid}}</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="价格" width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.origin_amount|CFMprice}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.item_num}}</div>
                                </template>
                            </el-table-column>
                          </el-table>
                      </template>
                  </el-table-column>
                  <el-table-column label="ID" width="100" align="center">
                      <template slot-scope="orderinfos">
                          <div class="tmall-order-id-style">{{orderinfos.row.id}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="抖店订单号" min-width="170" align="left">
                      <template slot-scope="orderinfos">
                          <div class="tmall-order-sn-style">{{orderinfos.row.trade_sn}}<div class="tmall-order-shopname-style">（卖家店铺：{{orderinfos.row.dshopname}}）</div></div>
                      </template>
                  </el-table-column>
                  <!--
                  <el-table-column label="订单金额" width="110" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.ordertotal|CFMprice}}</div>
                      </template>
                  </el-table-column>
                  -->
                  <el-table-column label="快递费" width="110" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.post_amount|CFMprice}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="实付金额" width="110" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.pay_amount|CFMprice}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="下单时间" width="170" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.create_time}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="支付时间" width="170" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.pay_time}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="状态" width="170" align="center">
                      <template slot-scope="orderinfos">
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==1">待确认/待支付（订单创建完毕）</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==105">已支付</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==2">备货中</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==101">部分发货</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==3">已发货（全部发货）</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==4">已取消</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==5">已完成（已收货）</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="是否生成出库单" width="120" align="center">
                      <template slot-scope="orderinfos">
                          <el-button type="warning" v-if="orderinfos.row.issell==0" round size="small" @click="createsells(orderinfos.row.id)">生成出库单</el-button>
                          <div v-if="orderinfos.row.issell==1" style="font-size:13px;">已生成</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="是否物流信息同步至抖店" width="120" align="center">
                      <template slot-scope="orderinfos">
                          <el-button type="warning" v-if="orderinfos.row.issend==0" round size="small" @click="sysshippings(orderinfos.row.id)">去同步</el-button>
                          <div v-if="orderinfos.row.issend==1" style="font-size:13px;">已同步</div>
                      </template>
                  </el-table-column>
              </el-table>

              <div class="block">
		      <!--分页begin-->
		      <el-pagination
			  	  @size-change="querypageSizeChange" 
			  	  @current-change="querypageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="query.rows">
		      </el-pagination>
		      <!--分页end-->
	      	  </div>
          </div>


            <!-- 拉取数据加载页 -->
            <div class="dshop-order-down-loading" :style="showorderloading"> 
                <div class="dshop-order-down-loading-main">
                    <div class="dshop-order-down-main-notice">上传抖店订单信息需要一点时间，请勿关闭当前页面</div>
                    <div class="dshop-order-down-main-percentout">
                        loading...
                        <span class="dshop-order-down-main-percent" :style="loadingpercent"></span>
                    </div>
                </div>
            </div>


          <!-- 展示错误信息 -->
          <el-dialog title="错误提示" :visible.sync="errorshowDialog" width="40%" top="10vh">
                <div style="display:inline-block;width:100%;color:red;margin-bottom:20px;font-size:13px;line-height:23px;text-align:right">共计：{{errorshows.length}} 条</div>
                <div class="dshop-order-down-error-shows" v-for="(item,index) in errorshows">
                    <img src="../../assets/error.png" />
                    {{item}}
                </div>
          </el-dialog>

          
            <!-- 批量导入抖店订单 -->
            <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
            <el-dialog title="批量导入抖店订单" :visible.sync="uploadDialog" width="45%" top="10vh">
                <div class="dshop-match-goods-import-notice">温馨提示：此处上传的商品表格为在抖店后台直接导出的订单表格</div>
                <div style="display:inline-block;width:100%" class="dshop-match-goods-import-out-main">
                    <div style="width:100%;float:left;margin-bottom:20px">
                        <div class="dshop-match-goods-import-count" style="float:left">共导入订单 {{uploadLists.length}} 个</div>
                        <el-button size="small" @click="uploadDialog = false" style="float:right">取 消</el-button>
                        <el-button type="primary" size="small" @click="saveimport" style="float:right;margin-right:1%">确定</el-button>
                        <el-button type="warning" size="small" @click="uploadmodel" style="float:right">导入订单</el-button>
                    </div>
                    <div class="dshop-match-goods-import-out" v-if="uploadLists.length > 0" v-loading="uploadloading">
                        <div class="dshop-match-goods-import-out-titles">
                            <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1 dshop-match-goods-import-out-title-back" style="width:80%"><div>抖店订单号</div></div>
                            <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid2 dshop-match-goods-import-out-title-back" style="width:20%"><div style="justify-content:center">操作</div></div>
                        </div>
                        <div class="dshop-match-goods-import-out-titles" v-for="(item,index) in uploadLists" :key="index">
                            <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1" style="width:80%"><div>{{item.trade_sn}}</div></div>
                            <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid2" style="width:20%">
                                <div style="justify-content:center">
                                    <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delupload(index)"></el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dshop-match-goods-import-out-no" v-if="uploadLists.length==0" v-loading="uploadloading">
                        <a @click="uploadmodel"><img src="../../assets/import_goods.png" /><span>请导入抖店订单信息</span></a>
                    </div>
                    <div style="width:100%;margin-top:20px;float:left;">
                        <div class="dshop-match-goods-import-count" style="float:left">共导入订单 {{uploadLists.length}} 个</div>
                        <el-button size="small" @click="uploadDialog = false" style="float:right">取 消</el-button>
                        <el-button type="primary" size="small" @click="saveimport" style="float:right;margin-right:1%">确定</el-button>
                        <el-button type="warning" size="small" @click="uploadmodel" style="float:right">导入订单</el-button>
                    </div>
                </div>
            </el-dialog>


          <!-- 查看出库单信息 -->
          <el-dialog title="出库单信息" :visible.sync="sellDialog"  width="65%" top="10vh">
			<div v-loading="sellloading" v-if="selllists.length==0" style="width:100%;height:200px;background:rgb(211,211,211,0.3);border-radius:6px;font-size:14px;font-weight:500;display:flex;justify-content:center;align-items:center">
				<img src="../../assets/packet.png" style="width:40px;height:40px"/>
				<span style="float:left;margin-left:1%">暂无出库单信息</span>
			</div>
			<div v-loading="sellloading" v-for="(item,index) in selllists" :key="index" style="display:inline-block;width:96%;padding:2%;background:rgb(211,211,211,0.3);border-radius:6px;margin-bottom:20px">
				<el-col :span="24">
					<el-col :span="24">{{item.documents}}</el-col>
					<el-col :span="24">收货人：{{item.name}}</el-col>
					<el-col :span="6">手机号码：{{item.phone}}</el-col>
					<el-col :span="24">详细地址：{{item.address}}</el-col>
				</el-col>
				<el-table :data="item.goods" style="float:left;width:100%;margin-top:10px">
					<el-table-column label="商品名称" prop="name"></el-table-column>
					<el-table-column label="数量" prop="nums" align="center" width="100"></el-table-column>
                    <el-table-column label="单位" prop="unit" align="center" width="100"></el-table-column>
					<el-table-column label="价格" prop="price" align="center" width="100"></el-table-column>
					<el-table-column label="小计" prop="total" align="center" width="100"></el-table-column>
                    <el-table-column label="类型" prop="type" align="center" width="100"></el-table-column>
				</el-table>
				</el-col>
			</div>
		  </el-dialog>


        <!-- 查看快递信息 -->
        <el-dialog title="查看快递信息" :visible.sync="myshippingDialog" top="10vh" width="70%" height="100%" :beforeClose="closemyshipping">
            <Showshipping  v-model="myorderid" :ordertype="myordertype" @finish="closemyshippingDialog"/>
            <div slot="footer" class="dialog-footer" style="text-align:right;margin-top:20px">
                <el-button size="small" @click="myshippingDialog = false">取 消</el-button>
            </div>
        </el-dialog>



      </div>
  </transition>  
</template>

<script>
import Showshipping from '@/components/mall/shipping/showshipping' //查看快递信息
export default {
  components: {Showshipping},
  data () {
    return {
        url:this.GLOBAL.domain+"Dshop/index",
        actionauth:'', //功能权限
		transitionshow:true,
        lists:[],
        query: {
            act:'getdshoporderlists',
            token:this.$cookies.get('token'),
            timetype:2,
            date:[],
            status:'',
            key:'',
            ischange:false,
            loading:false,
            rows:0,
            p:1,
            rollpage:10,
        },

        timetypelists:[{id:1,name:'订单创建时间'},{id:2,name:'订单支付时间'}],
        ispaylists:[{id:1,name:'已支付'},{id:2,name:'未支付'}],
        orderstatus:[
            {id:1,name:'待确认/待支付（订单创建完毕）'},
            {id:105,name:'已支付'},
            {id:2,name:'备货中'},
            {id:101,name:'部分发货'},
            {id:3,name:'已发货（全部发货）'},
            {id:4,name:'已取消'},
            {id:5,name:'已完成（已收货）'},
        ],

        getTmallOrderDialog:false,
        steplists: [
            {number:1,title:'填写抖店订单号'},
            {number:2,title:'确认抖店订单号'},
            {number:3,title:'完成'}
        ],
        Tmallorders: {
          index:0,
          loading:false,
          showorder1:'',
          showorder2:[],
        },

        showorderloading:{display:'none'},
        loadingpercent:{width:'0%'},
        errorshows:[],
        errorshowDialog:false,
        uploadDialog:false,
        uploadLists:[],
        uploadloading:false,

        sellDialog:false,
        sellloading:false,
        selllists:[],

        myshippingDialog:false,
        myorderid:'',
        myordertype:'dshop',

    }
  },
    
  mounted(){  
    this.getactionauth();
	this.getlists(); //获取订单信息详情
    this.createLockKongMing();
  },

  watch: {
	  
  },

  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
       var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
       var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
       return result;		
    }
  },
  
  methods:{

      /** 查看订单物流信息 **/
	  getpackshippings(id) {
		  this.myorderid=id;
		  this.myshippingDialog=true;
	  },
	  closemyshippingDialog() {
		  this.myorderid='';
		  this.myshippingDialog=false;
	  },
	  closemyshipping() {
		  this.myorderid='';
		  this.myshippingDialog=false;
	  },


      //将抖店信息同步至抖店
      sysshippings(id) {
          var resource = this.$resource(this.url);
          resource.save({act:'sysshipping',token:this.$cookies.get('token'),id:id}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.getlists();
                }
          }).catch((res) => {
              
          });
      },


      //查看销售出库单信息
      checksells(item) {
          this.sellDialog=true;
          this.sellloading=true;
          this.selllists=[];
          var resource = this.$resource(this.url);
          resource.save({act:'getsellinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.sellloading=false;
                }else{
                    this.selllists = JSON.parse(Base64.decode(res.data.Data));
                    this.sellloading=false;
                }
          }).catch((res) => {
              this.sellloading=false;
          });
      },


      //删除抖店订单
      delupload(index) {
          this.$delete(this.uploadLists,index);
      },


      //上传订单模板信息
      uploadmodel() {
          document.getElementById("fileupload").click();
      },
      
      //解析导入文件数据
      importfile(obj) {    
    	  let _this = this;
          let inputDOM = this.$refs.inputer;

          // 通过DOM取文件数据
          this.file = event.currentTarget.files[0];                
          var rABS = false; //是否将文件读取为二进制字符串
          var f = this.file;
          var outdata;
          var nums=0;
          var address='';
          var reader = new FileReader();
          var indexlists=[];
          this.uploadLists=[];
          this.uploadloading=true;
          FileReader.prototype.readAsBinaryString = function(f) {
            var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                outdata.forEach(function(item,index) {
                    if(indexlists.indexOf(item['主订单编号'])==-1) {
                        nums++;
                        _this.uploadLists.push({sort:nums,trade_sn:item['主订单编号']});
                        indexlists.push(item['主订单编号']);
                    }
                });

                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;     
                _this.uploadloading=false;      
            }
            reader.readAsArrayBuffer(f);
          }

          if(rABS) {
        	  reader.readAsArrayBuffer(f);
          } else {
              reader.readAsBinaryString(f);
          }    
      },


      //上传抖店订单信息
      uploadTmallOrder() {
          this.uploadDialog=true;
          this.uploadLists=[];
      },

      //保存上传订单信息
      saveimport() {
          if(this.uploadLists.length==0) {this.$message.error('请上传要导入的订单信息');return false;}

          //数据拆包分割，减少http连接数，增加服务器上传成功率
          var importmorepart=[];
          var allrows=this.uploadLists.length; //数据总条数
          var rollpage=10; //设置单次传输条数
          var p=Math.floor(allrows/rollpage); //获取页数
          (allrows%rollpage) > 0 ? p++ : '';
          
          var startpage=0;
          var endpage=0;
          var data=[];
          var sortinfos=[];
          var _this=this;
          for(var i=0; i<p; i++) {
             sortinfos=[];
             data=[];
             startpage=i*rollpage;
             endpage=(i+1)*rollpage-1;
             while(startpage <= endpage) sortinfos.push(startpage++);
             
             //提取组装数据
             sortinfos.forEach(function(nums,i) {
                 _this.uploadLists[nums] ? data.push(_this.uploadLists[nums]) : '';
             });
             importmorepart.push(data);
          }


          //开启加载特效
          this.showorderloading.display='flex';
          this.loadingpercent.width='0%';

          var _this=this;
          var num=0;
          var ordernums=importmorepart.length;
          var result;
          var percent;
          var timenum=0;
          var times=0;
          this.errorshows=[];

          var resource = this.$resource(this.url);
          importmorepart.forEach(function(item,i) {
              timenum++; times=timenum*2000;
              setTimeout(function() {
                  num++;
                  resource.save({act:'importdshoporders',token:_this.$cookies.get('token'),data:JSON.stringify(item)}).then((res) => {
                    
                    if(res.data.Result>0) {
                        var errorresult=JSON.parse(res.data.Message);
                        errorresult.forEach(function(itemerror,i) {_this.errorshows.push(itemerror)});
                        if(num!=ordernums) {
                            percent=num/ordernums*100;
                            _this.loadingpercent.width=percent+'%';
                        }
                        if(num==ordernums) {
                            percent=100;
                            _this.loadingpercent.width=percent+'%';
                            _this.showorderloading.display='none'; //关闭特效
                            _this.uploadDialog=false;
                            _this.query.p=1;
                            _this.query.rollpage=10;
                            _this.getlists();
                            if(_this.errorshows.length > 0) _this.errorshowDialog=true;
                        }

                    }else {
                        if(num!=ordernums) { //没有加载完时
                            percent=num/ordernums*100;
                            _this.loadingpercent.width=percent+'%';

                        }else { //已经加载完成
                            percent=100;
                            _this.loadingpercent.width=percent+'%';
                            _this.showorderloading.display='none'; //关闭特效
                            _this.uploadDialog=false;
                            _this.query.p=1;
                            _this.query.rollpage=10;
                            _this.getlists();
                            if(_this.errorshows.length > 0) _this.errorshowDialog=true;
                        }

                    }

                });

              },times);
          });
      },


     //生成销售出库单
     createsells(id) {
        var resource = this.$resource(this.url);
        resource.save({act:'Dshopcreatesell',token:this.$cookies.get('token'),id:id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.getlists(); //更新列表
            }
        }).catch((res) => {
            
        });
     },


     //获取订单信息详情
     getlists() {
        if(this.query.ischange) {
            this.query.p=1;
            this.query.rollpage=10;
        }

        this.query.loading=true;
        var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.query.rows=parseInt(res.data.count);
                this.query.loading=false;
            }
        }).catch((res) => {
            this.query.loading=false;
        });

     },

     querypageSizeChange(val) {
        this.query.rollpage = val;
        this.getlists();
	 },
	 querypageCurrentChange(val) {
		this.query.p = val;
		this.getlists();
	 },

    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.Tmall-notice-warning {display:inline-block;padding:5px 20px;width:calc(100% - 40px);background:#E4E7ED;border-radius:6px;font-size:12px;line-height:23px;color:red;}
.Tmall-notice-title {display:inline-block;width:100%;margin-top:20px;font-size:0}
.Tmall-notice-title-infos {float:left;display:flex;justify-content:center;align-items:center;margin-right:5%;}
.Tmall-notice-title-number {float:left;display:flex;justify-content:center;align-items:center;font-size:13px;font-weight:bold;border:2px solid #909399;color:#fff;background:#909399;width:25px;height:25px;border-radius:50%}
.Tmall-notice-title-line {float:left;width:100px;height:2px;border-radius:15px;background:#909399;margin: 0 0 0 10px;}
.Tmall-notice-title-content {float:left;height:40px;display:flex;justify-content:center;align-items:center;}
.Tmall-notice-title-content-big {color:#909399;font-size:14px;font-weight:540;padding:0 10px;}

.Tmall-title-actived .Tmall-notice-title-number {color:#fff;border-color:#67C23A;background:#67C23A;}
.Tmall-title-actived .Tmall-notice-title-line {background:#67C23A;}
.Tmall-title-actived .Tmall-notice-title-content-big {color:#67C23A;}
.Tmall-notice-orderlists {float:left;padding:5px 10px;margin:5px 10px 5px 0;border-radius:15px;background:#DCDFE6;color:#303133;font-size:12px;line-height:21px;}

.tmall-order-id-style {font-size:13px;}
.tmall-order-sn-style {font-size:14px;display:inline-block;}
.tmall-order-shopname-style {font-size:12px;display:inline-block;}
.tmall-order-ispay-style {font-size:13px;line-height:21px;display:inline-block;width:100%}
.tmall-order-status-style {font-size:13px;line-height:21px;display:inline-block;width:100%}
.tmall-order-reciever {display:inline-block;font-size:13px;line-height:23px;margin-bottom:10px}
.tmall-order-handels {display:inline-block;width:100%;}
.tmall-order-goods {display:inline-block;width:100%;}
.tmall-order-goods-gift {position:absolute;font-size:12px;line-height:12px;color:#fff;background:red;right:0;top:0;padding:3px;border-radius:6px;}
.tmall-order-goods-img {float:left;width:65px;height:65px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);border-radius:6px;display:flex;justify-content:center;align-items:center;position:relative;}
.tmall-order-goods-img img {border-radius:6px;max-width:85%;max-height:85%;}
.tmall-order-goods-name {float:left;width:calc(100% - 65px - 2px - 10px);margin-left:10px;line-height:23px;font-size:13px;}
.tmall-order-goods-spec {float:left;width:calc(100% - 65px - 2px - 10px);margin-left:10px;line-height:23px;font-size:12px;color:#999999}

.dshop-match-goods-import-notice {display:inline-block;width:calc(100% - 40px - 2px);padding:10px 20px;font-size:12px;line-height:12px;background:rgba(221,221,221,.2);border:1px solid rgba(221,221,221,.7);border-radius:6px;color:red;margin-bottom:20px}

.dshop-match-goods-import-out {display:inline-block;padding:20px;width:calc(100% - 40px);border-top:1px solid #EBEEF5;border-bottom:1px solid #EBEEF5;}
.dshop-match-goods-import-out-main .el-form-item__label {font-size:13px}
.dshop-match-goods-import-out-main .el-input {max-width:70%}

.dshop-match-goods-import-out-titles {display:inline-block;width:100%;font-size:0}
.dshop-match-goods-import-out-title {display:inline-block;font-size:13px;line-height:21px;font-weight:540;}
.dshop-match-goods-import-out-title-back {background:#F2F6FC}
.dshop-match-goods-import-out-title div {display:flex;align-items:center;width:calc(100% - 40px);padding:5px 20px;height:40px;}
.dshop-match-goods-import-out-title-wid1 {width:22.5%;}
.dshop-match-goods-import-out-title-wid2 {width:10%;}
.dshop-match-goods-import-count {float:right;color:red;margin-left:2%;font-size:13px;line-height:23px;padding:5px 0;margin-right:2%}
.dshop-match-goods-import-notice {display:inline-block;width:calc(100% - 40px - 2px);padding:10px 20px;font-size:12px;line-height:12px;background:rgba(221,221,221,.2);border:1px solid rgba(221,221,221,.7);border-radius:6px;color:red;margin-bottom:20px}

.dshop-match-goods-import-out-no {display:flex;justify-content:center;align-items:center;width:100%;height:150px;}
.dshop-match-goods-import-out-no a {float:left;min-width:30%;max-width:60%;padding:20px 10px;cursor:pointer;display:flex;justify-content:center;align-items:center;border:1px dashed #fff;background:#fff;transition:.3s all;border-radius:6px;}
.dshop-match-goods-import-out-no a:hover {border:1px dashed #f56c6c;background:#fef0f0}
.dshop-match-goods-import-out-no img {width:30px;height:30px;}
.dshop-match-goods-import-out-no span {height:30px;font-size:14px;line-height:14px;color:#999999;margin-left:5%;display:flex;align-items:center;}

.dshop-order-down-loading {position:fixed;width:100%;height:100%;top:0;left:0;background:rgba(0,0,0,.9);z-index:10000;display:flex;justify-content:center;align-items:center;}
.dshop-order-down-loading-main {display:inline-block;width:30%;text-align:center;}
.dshop-order-down-main-notice {font-size:13px;line-height:23px;color:#ffdd03;-webkit-animation-timing-function:ease-in-out;-webkit-animation-name:goingdown;-webkit-animation-duration:1000ms;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;}
.dshop-order-down-main-percentout {width:60%;text-align:center;position:relative;padding:5px;font-size:13px;line-height:23px;border-radius:15px;overflow:hidden;border:1px solid #ffdd03;color:#ffdd03;margin:0 auto;margin-top:20px;}
.dshop-order-down-main-percent {position:absolute;height:100%;background:#ffdd03;border-radius:0 15px 15px 0;transition:.6s all;top:0;left:0;}

@-webkit-keyframes goingdown {
	0% {
	    opacity:0;
	    text-shadow:0 0 0 #ffdd03;
    }
    100% {
	    opacity:1;
    	text-shadow:0 0 10px #ffdd03;
    }
}

.dshop-order-down-error-shows {display:flex;align-items:center;width:calc(100% - 2px - 40px);padding:3px 20px;border:1px solid #f56c6c;background:#fef0f0;font-size:12px;color:#f56c6c;border-radius:6px;line-height:23px;margin-bottom:10px;}
.dshop-order-down-error-shows img {width:20px;height:20px;border-radius:50%;margin-right:10px;}
.dshop-match-goods-import-count {float:right;color:red;margin-left:2%;font-size:13px;line-height:23px;padding:5px 0;margin-right:2%}
</style>


// WEBPACK FOOTER //
// src/components/doudian/DoudianOrders.vue